import {
  isPartialMaterialCharacteristicsWithShade,
  type DeepPartial,
  type MaterialCharacteristics,
} from "@jasper/client-models";

export const normalizeMaterialCharacteristics = (
  value: DeepPartial<MaterialCharacteristics>
): DeepPartial<MaterialCharacteristics> => {
  if (!value) return value;

  if (
    !isPartialMaterialCharacteristicsWithShade(value) &&
    "shadeCharacteristics" in value
  ) {
    return { ...value, shadeCharacteristics: undefined };
  }

  return value;
};
